import React, { useState, useEffect } from 'react';
import $ from 'jquery';

// Components
import FeaturedList from './FeaturedList';
import UpcomingList from './UpcomingList';
import RecipeCards from './RecipeCards';
import ListPager from './ListPager';
import Loader from './Loader';

// Config
import { AJAX_URL, TAXONOMY, TEMPLATE, COOP_ID } from '../../config/index.js';

let pageWasInteractedWith = false;

const el = document.getElementById('taxonomy-list-app');
const mainArticles = el ? JSON.parse(el.dataset.articleIds || '[]') : [];

export default function TaxonomyList() {
  const [isLoading, setLoading] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [contestsList, setContestList] = useState([]);
  const [coop, setCoop] = useState([]);
  const [ads, setAds] = useState([]);
  const [featuredList, setFeaturedList] = useState([]);
  const [query, setQuery] = useState({
    terms: TAXONOMY.slug,
    coop_id: COOP_ID,
    post_type: window.hasOwnProperty('taxConfig')
      ? window.taxConfig.post_type
      : 'post',
    exclude_posts: mainArticles
  });

  // hacky way to prevent the automatic scroll-trigger to top of container on pageload.. guys..
  $(document).one('click', () => {
    pageWasInteractedWith = true;
  });

  // Pagination State
  const [limit, setLimit] = useState(12);
  const [pagerIndex, setPagerIndex] = useState(0);
  const [paginatedEvents, setPaginatedEvents] = useState([]);
  const [paginatedFeatured, setPaginatedFeatured] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const remainingPosts = [];
  const queryAmount = 400;
  const [loadingFinished, setLoadingFinished] = useState(false);

  const handlePagination = (list, currentIndex, featured = false) => {
    if (!featured) {
      setTotalPages(Math.ceil(list.length / limit));
    }

    const lastPage = totalPages - 1;

    if (!featured) {
      if (currentIndex >= totalPages) {
        setPagerIndex(0);
        return;
      } else if (currentIndex < 0) {
        setPagerIndex(lastPage);
        return;
      }
    }

    const startIndex = limit * parseInt(currentIndex);
    const endIndex = parseInt(startIndex) + parseInt(limit);
    const selection = list.slice(startIndex, endIndex);

    if (!featured) {
      setPaginatedEvents(selection);
    } else {
      setPaginatedFeatured(selection);
    }

    // Scroll to top of container after changing pagination (settings).
    if (pagerIndex || (!pagerIndex && pageWasInteractedWith)) {
      const scrollOffset = document.body.classList.contains('admin-bar')
        ? 105
        : 70;

      window.scrollTo({
        top:
          window.pageYOffset +
          parseInt(
            document.getElementById('taxonomy-list-app').getBoundingClientRect()
              .top
          ) -
          scrollOffset,
        behavior: 'smooth'
      });
    }
  };

  const prevPage = () => setPagerIndex(pagerIndex - 1);
  const nextPage = () => setPagerIndex(pagerIndex + 1);

  const pullRemainingPosts = (offset) => {
    let initializeGPT = setInterval(() => {
      if (offset === 450) {
        window.initializeAds();
        clearInterval(initializeGPT);
      }
    }, 500);

    $.ajax({
      type: 'POST',
      url: `${AJAX_URL}post_wlQueryTaxonomy`,
      dataType: 'json',
      encode: true,
      data: { ...query, offset, queryAmount },
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ success, data: { taxonomy_posts } }) => {
        if (success) {
          remainingPosts.push(...taxonomy_posts);
          pullRemainingPosts(offset + queryAmount);
        } else {
          setEventList(remainingPosts);
          setLoadingFinished(true);
        }
      })
      .catch((err) => console.log(err.message));
  };

  useEffect(() => {
    if (query.terms === undefined && query.post_type === undefined) return;

    setLoading(true);
    $.ajax({
      type: 'POST',
      url: `${AJAX_URL}post_wlQueryTaxonomy`,
      dataType: 'json',
      encode: true,
      data: { ...query, offset: 0 },
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then(({ data: { taxonomy_posts, contests, coop, ads } }) => {
        setEventList(taxonomy_posts);
        remainingPosts.push(...taxonomy_posts);
        setContestList(contests);
        setCoop(coop);
        setAds(ads);

        pullRemainingPosts(50); // initial 'numberposts' amount in ajax func.
      })
      .catch((err) => console.log(err.message));
  }, [query]);

  const createFeaturedList = (list) => {
    let featuredList = [];

    for (const item of list.slice(0, 2)) {
      featuredList.push(item);
    }

    return featuredList;
  };

  useEffect(() => {
    eventList.length > 0 ? setLoading(false) : '';

    setFeaturedList(createFeaturedList(eventList));

    handlePagination(eventList, pagerIndex);
  }, [eventList]);

  useEffect(() => {
    if (TEMPLATE === 'templates/page-category-sub.php') {
      let eventListNew = eventList.slice(2);
      handlePagination(eventListNew, pagerIndex);
      handlePagination(featuredList, pagerIndex, true);
    } else {
      handlePagination(eventList, pagerIndex);
    }
  }, [pagerIndex, featuredList, limit]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      {TEMPLATE === 'templates/page-category-sub.php' && (
        <FeaturedList
          taxonomyArticle={paginatedFeatured}
          contests={contestsList}
          coops={coop}
        />
      )}
      <div className="container container--xl">
        {TEMPLATE === 'templates/page-recipes.php' ? (
          <RecipeCards recipes={paginatedEvents} ads={ads} />
        ) : (
          <UpcomingList taxonomyArticles={paginatedEvents} ads={ads} />
        )}
        <ListPager
          changeLimit={setLimit}
          limit={limit}
          setPagerIndex={setPagerIndex}
          nextPage={nextPage}
          prevPage={prevPage}
          pagerIndex={pagerIndex}
          totalEvents={loadingFinished ? eventList.length : 'loading'}
          totalPages={totalPages}
          paginatedItemCount={paginatedEvents.length * (pagerIndex + 1)}
        />
      </div>
    </>
  );
}
